import { CompositeLayer } from '@deck.gl/core'
import { ScatterplotLayer } from '@deck.gl/layers'

const defaultProps = {
  ...CompositeLayer.defaultProps,
}

/**
 * プロット表示用カスタムレイヤー
 */
class PlotCompositeLayer extends CompositeLayer {
  renderLayers() {
    const { id, data, _subLayerProps, ...restProps } = this.props
    const { others: othersProps, highlighted: highlightedProps } =
      _subLayerProps || {}

    return [
      // 通常のプロットを描画するレイヤー
      new ScatterplotLayer({
        data,
        id: `${id}-others`,
        ...restProps,
        ...othersProps,
      }),
      // ハイライト対象のプロットを描画するレイヤー
      new ScatterplotLayer({
        data,
        id: `${id}-highlighted`,
        ...restProps,
        ...highlightedProps,
      }),
    ]
  }
}

PlotCompositeLayer.layerName = 'PlotCompositeLayer'
PlotCompositeLayer.defaultProps = defaultProps

export { PlotCompositeLayer }
